import styles from "./styles";

export const Footer = () => {
  return (
    <div css={styles.FooterWrapper}>
      <p>JMW - Chartered Accountants</p>
    </div>
  );
};